<app-tpl-form
  [title]="packTitle"
  (save)="save()"
  (cancel)="cancel()"
  [saveDisabled]="!formPack.valid"
  [deepLinkButtonTooltipText]="'DEEPLINK.DISABLE_PACKS' | translate"
  [deepLinkDisabled]="this.formPack.controls.type.value === 'MARKETING' && this.formPack.controls.status.value === 'PUBLISHED'"
  [displayDeeplinkBtn]="isEdit"
  [deepLinkData]="{
    functionalId: pack.key,
    resource: 'packs',
    domain: pack.domain,
    lang: lang,
    market: pack.market,
    type: pack.type ? pack.type.toLowerCase() : ''
  }"
>
  <form [formGroup]="formPack">
    <mat-tab-group mat-align-tabs="start" id="PacksModifyPackBtns">
      <mat-tab [label]="'REFDATA.PACKS.TABS.PACK' | translate">
        <app-pack-tab-component
          id="PacksModifyPackBtn1"
          #packTabComponent
          [formPack]="formPack"
          [isEdit]="isEdit"
          [pack]="pack"
        ></app-pack-tab-component>
      </mat-tab>
      <mat-tab [label]="'REFDATA.PACKS.TABS.RECIPES' | translate" [disabled]="!isEdit">
        <app-pack-recipe-tab
          #packRecipeTabComponent
          [pack]="pack"
          [isEdit]="isEdit"
          [packId]="packId"
          [formPack]="formPack"
          (publishPack)="this.publishPack()"
          (packChanged)="this.refreshPack()"
        ></app-pack-recipe-tab>
      </mat-tab>
    </mat-tab-group>
  </form>
</app-tpl-form>
